<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهـداء">
<h1><span dir="rtl">الإهـداء</span></h1>
<p><span dir="rtl">أهدي هذا الكتاب في المقدمة للوعي الروحي لوالدي السيد سامح حجازين الذي فارق</span> <span dir="rtl">جسده الحياة لهذا العالم بتاريخ 23/11/2019، حيث قطعتُ أمامه <strong>الوعد</strong> قبل ثلاثة أيام من وفاته بأنني سأكون مصدر فخره في يوم <br/><br/>ما وها هو هذا اليوم قد جاء، وأعلم بأنه يشعر بالفخر بي الآن في مكان ما.</span></p>
<p style="text-indent:0px;"><span dir="rtl">أهدي كتابي أيضاً لأفراد عائلتي ولأصدقائي جميعاً الذين هم من أهم محاور فرحي واهتمامي على الدوام.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?5787e76e